import { mapGetters, mapActions } from 'vuex'
// import { forEach } from 'lodash'
import { formatDate } from 'src/helpers'
import SimpleMDE from 'simplemde'
import 'simplemde/dist/simplemde.min.css'
import ls from 'local-storage'
export default {
  data () {
    return {
      localPromotion: {
        id: 0,
        code: '',
        discount: '',
        is_percent: false,
        max_discount: '',
        quantity: '',
        is_only: false,
        start_date: '',
        end_date: '',
        is_active: true,
        quantity_per_user: '',
        source: '-1',
        carrier_id: '0',
        city_to: '0',
        city_from: '0',
        description: '',
        image: ''
      },
      rules: {
        code: [
          {required: true, message: 'Bạn chưa nhập mã giảm giá', trigger: 'change'}
        ],
        discount: [
          {required: true, message: 'Bạn chưa nhập số tiền giảm giá', trigger: 'change'}
        ],
        start_date: [
          {required: true, message: 'Bạn chưa nhập ngày bắt đầu', trigger: 'change'}
        ],
        end_date: [
          {required: true, message: 'Bạn chưa nhập ngày kết thúc', trigger: 'change'}
        ]
      },
      submitting: false,
      uploadLogoUrl: process.env.API_URI + '/promotions/upload',
      uploadHeader: {},
      image: {},
      simplemde: null
    }
  },
  computed: {
    ...mapGetters('promotion', ['promotionHelpers']),
    ...mapGetters('carrier', ['carriers']),
    ...mapGetters('city', ['cities'])
  },
  methods: {
    ...mapActions('promotion', ['getPromotionHelpers']),
    ...mapActions('carrier', ['getAllCarriers']),
    ...mapActions('city', ['getAllCity']),
    newPromotion () {
      this.localPromotion = {
        id: 0,
        code: '',
        discount: '',
        is_percent: false,
        max_discount: '',
        quantity: '',
        is_only: false,
        start_date: '',
        end_date: '',
        is_active: true,
        quantity_per_user: '',
        source: '-1',
        carrier_id: '0',
        city_to: '0',
        city_from: '0',
        description: '',
        image: ''
      }
    },
    dateFormat (name) {
      this.localPromotion[name] = formatDate(this.localPromotion[name])
    },
    handleLogoUpload (res, file) {
      if (res.code) {
        this.image = res.data
        this.localPromotion.image = res.data.name
      }
    },
    beforeLogoUpload (file) {

    }
  },
  mounted () {
    this.uploadHeader.Authorization = `Bearer ${ls.get('authen').access_token}`
    this.newPromotion()
    if (!Object.keys(this.promotionHelpers).length) {
      this.getPromotionHelpers()
    }
    if (!this.carriers.length) {
      this.getAllCarriers({limit: -1})
    }
    if (!this.cities.length) {
      this.getAllCity({limit: -1})
    }
    this.$nextTick(() => {
      this.simplemde = new SimpleMDE({
        element: document.getElementsByName('description')[0]
      })
    })
  },
  watch: {
    localPromotion: {
      handler: function (value) {
        if (this.watching) {
          this.changedData = true
        }
      },
      deep: true
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/promotion/mixins/index.js